// LP-HEROセクション

(function(){
  const buttons = document.querySelectorAll('.js-open-video');
  const modal   = document.getElementById('yt-modal');
  const iframe  = document.getElementById('yt-iframe');
  const CLOSE_SELECTORS = '.js-close-video, .yt-backdrop';

  if (!buttons.length || !modal || !iframe) return;

  function openModal(ytid){
    const src = `https://www.youtube.com/embed/${ytid}?rel=0&showinfo=0&autoplay=1&mute=1`;
    iframe.setAttribute('src', src);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal(){
    iframe.setAttribute('src', '');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  buttons.forEach(btn=>{
    btn.addEventListener('click', function(){
      const vid = this.getAttribute('data-yt');
      if (vid) openModal(vid);
    });
  });

  modal.addEventListener('click', (e)=>{
    if (e.target.closest('.js-close-video') || e.target.matches(CLOSE_SELECTORS)) closeModal();
  });
  document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

// 購入フォームへ移動：HERO内の「今すぐ購入」ボタン
document.addEventListener('DOMContentLoaded', () => {
  // HERO内の「今すぐ購入」ボタン
  const purchaseBtn = document.querySelector('.hero .btn.primary.purchase');
  if (!purchaseBtn) return;

  purchaseBtn.addEventListener('click', (e) => {
    e.preventDefault();

    // 商品タイトル（＝オプション選択の起点）へ戻す
    // ※ HERO内にもh1があるので「.hero の外のh1」を取る
    const title = Array.from(document.querySelectorAll('main h1'))
      .find(el => !el.closest('.hero'));
    if (title) {
      title.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // 万一タイトルが取れないときは従来の #purchase にフォールバック
      location.hash = '#purchase';
    }
  });
});

// LP-Description セクション

document.addEventListener('DOMContentLoaded', () => {
  // ===== タブ：このブロックだけ新しいものに差し替え =====
  const tablist = document.querySelector('.ip-tabs[role="tablist"]');
  if (tablist) {
    const tabs = Array.from(tablist.querySelectorAll('.ip-tab')).filter(btn => btn.hasAttribute('data-panel'));
    const panels = tabs
      .map(t => document.getElementById(t.getAttribute('data-panel')))
      .filter(Boolean);

    const sync = (activeTab) => {
      tabs.forEach(btn => {
        const on = (btn === activeTab);
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
});
      panels.forEach(p => {
        const on = (p.id === activeTab.getAttribute('data-panel'));
        p.classList.toggle('active', on);
      });
  };

    let current = tabs.find(t => t.classList.contains('active')) || tabs[0];
    if (current) sync(current);

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
      e.preventDefault();
        const pid = tab.getAttribute('data-panel');
        const panel = document.getElementById(pid);
        if (!panel) return;
        sync(tab);
    });
  });
  }

  // ===== アコーディオン（あなたの既存のままでOK） =====
  document.querySelectorAll('.accordion-title').forEach(title => {
    title.addEventListener('click', () => {
      title.classList.toggle('active');
    });
  });

  // ===== Lightbox（複数サムネに対応） =====
  (function () {
    const thumbs = document.querySelectorAll('.js-lightbox-thumb');
    const lb = document.getElementById('quality-lightbox');
    if (!thumbs.length || !lb) return;

    const lbImg = lb.querySelector('.lightbox-img');
    const btnClose = lb.querySelector('.lightbox-close');

    const onKey = (e) => { if (e.key === 'Escape') close(); };

    const open = (fullSrc) => {
      lbImg.src = fullSrc;
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
    };
    const close = () => {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      lbImg.src = '';
      document.removeEventListener('keydown', onKey);
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full') || thumb.src;
        open(fullSrc);
      });
    });
    btnClose.addEventListener('click', close);
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
  })();
});

document.addEventListener('DOMContentLoaded', () => {
  // 「マップを見る」リンク → #map にスムーズスクロール
  document.querySelectorAll('a[href^="#map"]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.getElementById('map');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});

  // ===== 「#map」へ飛ぶ時：Tab3/アコーディオンを開いてからスクロール =====
  const scrollToWithOpen = (el) => {
    if (!el) return;

    // 1) 対象パネルのタブを開く（Tab3など）
    const panel = el.closest('.ip-panel');
    if (panel && !panel.classList.contains('active')) {
      const tabBtn = document.querySelector(`.ip-tab[data-panel="${panel.id}"]`);
      if (tabBtn) tabBtn.click(); // 既存のタブ同期ロジックをそのまま使う
    }

    // 2) 対象がアコーディオン内なら開く
    const accContent = el.closest('.accordion-content');
    if (accContent && (accContent.style.display === '' || getComputedStyle(accContent).display === 'none')) {
      const title = accContent.previousElementSibling;
      if (title && title.classList.contains('accordion-title') && !title.classList.contains('active')) {
        title.classList.add('active'); // 開く（CSSで .active + .accordion-content が表示）
      }
    }

    // 3) 少し待ってからスムーズスクロール
    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  };

  // 「マップを見る」リンク（#map）にフック
  document.querySelectorAll('a[href="#map"], a[href^="#map"]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('map');
      scrollToWithOpen(target);
    });
  });

  // ページ読み込み時にURLに #map が付いていた場合も対応
  if (location.hash === '#map') {
    const target = document.getElementById('map');
    scrollToWithOpen(target);
  }

/* =========================================================
  custom-shop-guide（SP アコーディオン）
  ---------------------------------------------------------
  クリックした <li> に is-open を付与して開閉する。
  全体的に軽量・衝突しない書き方。
=======================================================*/
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.ip-sp-nav > li');
  items.forEach(function (item) {
    const btn = item.querySelector('.ip-sp-btn');
    const content = item.querySelector('.ip-sp-content');
    if (!btn || !content) return;
    btn.addEventListener('click', function () {
      // すでに開いている場合 → 閉じる
      if (item.classList.contains('is-open')) {
        item.classList.remove('is-open');
        return;
      }
      // 他を閉じる（アコーディオン仕様にしたい場合）
      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
        }
      });
      // クリックされたものを開く
      item.classList.add('is-open');
    });
  });
});

// LP-Returnabla セクション

document.addEventListener('DOMContentLoaded', function () {
  // ボタンで開閉
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-rs-toggle]');
    if (!btn) return;

    const root = btn.closest('.rs');
    if (!root) return;

    const open = root.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? '閉じる' : '続き（詳細）を見る';
  });

  // 見出し/カードのクリックでも開ける（閉じている時のみ）
  document.addEventListener('click', function (e) {
    const titleOrCard = e.target.closest('.rs-step__title, .rs-step');
    if (!titleOrCard) return;

    const root = titleOrCard.closest('.rs');
    if (!root || root.classList.contains('is-open')) return;

    if (e.target.closest('a,button,summary')) return;

    const btn = root.querySelector('[data-rs-toggle]');
    if (btn) btn.click();
  });
});

/* =========================================================
   SHOP-2 第1回（2026-09）: Clarity イベント・位置到達・MCV②のポップアップ
   - すべて「押した／開いた／画面に入った」の記録だけ。表示や購入の流れは変えない
   - GA4 にも同じイベントを既存の gtag で送る（2026-09-14 SHOP-2-3: 二重計測テスト合格後に全イベントへ拡大）
   ========================================================= */
(function () {
  var GA4_ID = 'G-77EN11KWZ1';
  function track(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, { send_to: GA4_ID });
    } catch (e) {}
  }
  window.uwpTrack = track;

  document.addEventListener('DOMContentLoaded', function () {
    // 等級のタグ（Clarity のフィルタ用）
    var g = document.querySelector('[data-uwp-grade]');
    try { if (g && typeof window.clarity === 'function') window.clarity('set', 'product_grade', g.getAttribute('data-uwp-grade')); } catch (e) {}

    // data-track を持つ要素を押した
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-track]');
      if (el) track(el.getAttribute('data-track'));
    });

    // タブ
    var tabNames = { tab1: 'pp_tab_quality', tab2: 'pp_tab_support', tab3: 'pp_tab_voice' };
    document.querySelectorAll('.ip-tab[data-panel]').forEach(function (t) {
      t.addEventListener('click', function () { var n = tabNames[t.getAttribute('data-panel')]; if (n) track(n); });
    });

    // アコーディオン（開いたときだけ。既存の toggle の後に動く）
    document.querySelectorAll('.accordion-title[data-acc]').forEach(function (t) {
      t.addEventListener('click', function () { if (t.classList.contains('active')) track('pp_acc_open_' + t.getAttribute('data-acc')); });
    });

    // 返品交換できる配送の「続き（詳細）を見る」（開いたときだけ）
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rs-toggle]');
      if (b && b.getAttribute('aria-expanded') === 'true') track('pp_rs_more');
    });

    // 商品写真をめくった（利用者の操作だけ）
    document.addEventListener('slideshow:select', function (e) {
      if (e && e.detail && e.detail.userInitiated) track('pp_gallery_slide');
    }, true);

    // カートに追加
    document.addEventListener('click', function (e) {
      if (e.target.closest('button.add-to-cart-button, button[name="add"]')) track('pp_add_to_cart');
    });

    // 位置到達（1回だけ）
    // カートボタン（SC Product Options が読み込み後に複製する bold_clone）と
    // Judge.me のレビュー欄は、ページ読み込みより後にできる。見つかるまで最大20秒探し直す
    // （2026-09-14 修正: 最初は元の非表示ボタンを掴んでしまい pp_reach_cart が記録されていなかった）
    if ('IntersectionObserver' in window) {
      var targets = [
        ['pp_reach_pyramid', ['.uwp-pyr']],
        ['pp_reach_price', ['product-price']],
        ['pp_reach_cart', ['button.add-to-cart-button.bold_clone']],
        ['pp_reach_desc', ['.product-details rte-formatter', '.uwp-desc']],
        ['pp_reach_reviews', ['#judgeme_product_reviews', '.jdgm-rev-widg']]
      ];
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { track(en.target.getAttribute('data-uwp-reach-name')); io.unobserve(en.target); }
        });
      }, { threshold: 0.1 });
      var pending = targets.slice();
      var tries = 0;
      (function attach() {
        pending = pending.filter(function (t) {
          for (var i = 0; i < t[1].length; i++) {
            var el = document.querySelector(t[1][i]);
            if (el) { el.setAttribute('data-uwp-reach-name', t[0]); io.observe(el); return false; }
          }
          return true;
        });
        if (pending.length && ++tries <= 40) setTimeout(attach, 500);
      })();
    }

    // MCV②: 注文フォームの「返品交換できる配送」の詳細ポップアップを開く
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-uwp-open-help]');
      if (!b) return;
      var key = (b.getAttribute('data-uwp-open-help') || '').replace(/\s+/g, '');
      var set = Array.prototype.find.call(document.querySelectorAll('.bold_option_set'), function (s) {
        return (s.innerText || '').replace(/\s+/g, '').indexOf(key) === 0;
      });
      var help = set && set.querySelector('.uwp-opt-help-btn');
      if (help) { help.click(); return; }
      var rs = document.getElementById('returnable-shipping');
      if (rs) {
        var more = rs.querySelector('[data-rs-toggle]');
        if (more && more.getAttribute('aria-expanded') !== 'true') more.click();
        rs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

